export const navigation = [
  { label: 'Products', href: '#products' },
  { label: 'Solutions', href: '#solutions' },
  { label: 'Architecture', href: '#architecture' },
  { label: 'System', href: '#system' },
]

export const products = [
  {
    key: 'agent-commerce',
    index: '01',
    name: 'Agent commerce',
    summary: 'A private-build payment path for APIs and tools: machine-native charges, wallet-signed payment, and durable receipts.',
    cta: 'Talk about agent payments',
    flow: {
      label: 'Illustrative protocol path',
      nodes: [
        { name: 'HTTP 402 challenge', detail: 'Gateway · off-chain' },
        { name: 'MsgPayCharge', detail: 'Wallet · signed' },
        { name: 'Charge + paid event', detail: 'MPP · on-chain' },
      ],
      module: 'PaymentReceipt / derived response',
    },
  },
  {
    key: 'issuance',
    index: '02',
    name: 'Issuance',
    summary: 'An institutional trust base designed around reserve deposits, mint and redeem boundaries, and queryable coverage.',
    cta: 'Talk about issuance',
    flow: {
      label: 'Illustrative issuance boundary',
      nodes: [
        { name: 'Reserve deposit', detail: 'Bank transfer · off-chain' },
        { name: 'Mint boundary', detail: 'Issuer · on-chain' },
        { name: 'Coverage query', detail: 'Public proof · on-chain' },
      ],
      module: 'Institutional stables / private build',
    },
  },
  {
    key: 'convert-settle',
    index: '03',
    name: 'Convert and settle',
    summary: 'A planned orchestration layer for exact quotes and settlement evidence across treasury and agent workflows.',
    cta: 'Talk about settlement',
    flow: {
      label: 'Planned settlement route',
      nodes: [
        { name: 'Exact quote', detail: 'Router · off-chain' },
        { name: 'Signed intent', detail: 'Wallet · signed' },
        { name: 'Evidence', detail: 'Observer · mixed' },
      ],
      module: 'Convert + settle / planned',
    },
  },
  {
    key: 'vaults-controls',
    index: '04',
    name: 'Vaults and controls',
    summary: 'Native vault primitives for roles, pauses, claims, and recovery boundaries, surfaced through operable software.',
    cta: 'Talk about controls',
    flow: {
      label: 'Illustrative capital controls',
      nodes: [
        { name: 'Deposit', detail: 'Vault custody · on-chain' },
        { name: 'Bounded epoch', detail: 'Settlement · on-chain' },
        { name: 'Claim', detail: 'Escrow · on-chain' },
      ],
      module: 'Native vaults / private build',
    },
  },
]

export const planes = [
  {
    key: 'control',
    name: 'Control plane',
    chain: 'No',
    summary: 'Agents, APIs, dashboards, quotes, policy UX, and compliance.',
  },
  {
    key: 'execution',
    name: 'Execution plane',
    chain: 'Mixed',
    summary: 'Transaction preparation, settlement observation, retries, receipts, and recovery.',
  },
  {
    key: 'settlement',
    name: 'Settlement plane',
    chain: 'Yes',
    summary: 'Balances, mint and redeem, final payments, vault ownership, and proofs.',
  },
]

export const audiences = [
  {
    key: 'ai-builders',
    label: 'For AI builders',
    title: 'Charge, settle, receipt',
    summary: 'Designed to monetize tools and agent workflows with machine payments derived from durable settlement evidence.',
  },
  {
    key: 'institutions',
    label: 'For institutions',
    title: 'Issue, redeem, prove',
    summary: 'A private-build path toward full-reserve stable value with coverage, redeemability, and calm operational controls.',
  },
]

export const systemLoop = [
  {
    key: 'issue',
    index: '01',
    name: 'Issue',
    summary: 'Target reserve parity for issued stable value.',
    plane: 'Settlement',
    boundary: 'On-chain',
    tone: 'settlement',
  },
  {
    key: 'hold',
    index: '02',
    name: 'Hold',
    summary: 'Apply planned vault and treasury policy.',
    plane: 'Control',
    boundary: 'Mixed',
    tone: 'neutral',
  },
  {
    key: 'pay',
    index: '03',
    name: 'Pay',
    summary: 'Prepare value movement for humans, agents, and apps.',
    plane: 'Execution',
    boundary: 'Signed',
    tone: 'neutral',
  },
  {
    key: 'settle',
    index: '04',
    name: 'Settle',
    summary: 'Target conversion and finalization with evidence.',
    plane: 'Settlement',
    boundary: 'On-chain',
    tone: 'settlement',
  },
  {
    key: 'prove',
    index: '05',
    name: 'Prove',
    summary: 'Derive receipts, coverage, audit, and recovery evidence.',
    plane: 'Evidence',
    boundary: 'Mixed',
    tone: 'neutral',
  },
]

export const demo = {
  eyebrow: 'Next step',
  title: 'See the settlement loop in context',
  summary: 'Walk through agent payments, institutional issuance, and settlement evidence with your team.',
  cta: 'Book a demo',
  prompt: 'Tell us what you need to settle.',
}

export default {
  navigation,
  products,
  planes,
  audiences,
  systemLoop,
  demo,
}
